import React from 'react';
import { CreditPurchase } from '../components/Credits/CreditPurchase';

const BuyCreditsPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-base-content">Buy Credits</h1>
        <p className="text-base-content/70 mt-2">Purchase credits to process more resumes</p>
      </div>
      
      {/* Purchase options taking full width */}
      <div className="bg-base-100 rounded-lg shadow-lg p-6 border border-base-300">
        <CreditPurchase />
      </div>
    </div>
  );
};

export default BuyCreditsPage; 